<app-toolbar></app-toolbar>

<div class="project-detail-container">
  <!-- Header con título del proyecto -->
  <div class="project-header">
    <div class="project-title-section">
      <div class="project-info">
        <h1 class="project-title">
          {{ projectDetail?.name || projectName | titleFormat }}
        </h1>
        <p class="project-description">{{ projectDetail?.description }}</p>

        <!-- Navigation anchors -->
        <div class="project-navigation">
          <a href="#technologies" class="nav-anchor tech"> Technologies </a>
          <a href="#certificates" class="nav-anchor"> Certificates </a>
          <a href="#comments" class="nav-anchor"> Comments </a>
        </div>
      </div>
    </div>
  </div>

  <!-- Sección Technologies -->
  <div class="content-section" id="technologies" style="padding: 48px 24px">
    <div class="section-header">
      <h2>Technologies</h2>
      <p class="section-subtitle">ECS Software Engineering Projects</p>
    </div>

    <div class="technologies-grid">
      <div
        class="technology-card"
        *ngFor="let tech of projectDetail?.technologies"
        [class]="'status-' + tech.statusColor"
      >
        <div class="card-content">
          <!-- Columna izquierda: Icono + Status -->
          <div class="tech-left-column">
            <div class="tech-icon" [class]="'icon-' + tech.statusColor">
              <img
                [src]="getTechIconPath(tech.statusColor)"
                [alt]="tech.status + ' icon'"
                class="tech-icon-svg"
              />
            </div>
            <span class="status-label" [class]="'word-' + tech.statusColor">
              {{ tech.status }}
            </span>
          </div>

          <!-- Columna derecha: Título + Detalles -->
          <div class="tech-right-column">
            <h3 class="tech-title">{{ tech.name | titleFormat }}</h3>

            <div class="tech-details">
              <div class="tech-row">
                <span class="label">Current Version</span>
                <span class="value">{{ tech.currentVersion }}</span>
              </div>
              <div class="tech-row">
                <span class="label">End of Life</span>
                <span class="value">{{ tech.endOfLife | dateFormat }}</span>
              </div>
              <div class="tech-row">
                <span class="label">Recommended Version</span>
                <span class="value">{{
                  getRecommendedVersion(tech.name, tech.currentVersion)
                }}</span>
              </div>
              <div class="tech-row">
                <span class="label">Status +1 Year</span>
                <span
                  class="status-badge"
                  [class]="'badge-' + tech.statusColor"
                >
                  <span class="status-indicator"></span>
                  {{
                    tech.status === "ACTIVE SUPPORT"
                      ? "Active Support"
                      : tech.status === "SECURITY SUPPORT"
                        ? "Security Support"
                        : "No Support"
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Sección Certificates -->
  <div
    class="content-section certificates-section"
    style="padding: 48px 24px"
    id="certificates"
  >
    <div class="section-header">
      <h2>Certificates</h2>
      <p class="section-subtitle">ECS Software Engineering Projects</p>
    </div>

    <!-- Loading state: skeleton cards -->
    <div *ngIf="isLoadingCertificates" class="certificates-grid">
      <div class="certificate-card skeleton-card" *ngFor="let s of [0, 1, 2]">
        <div class="card-content">
          <!-- Left column skeleton -->
          <div class="cert-left-column">
            <div class="skeleton-block skeleton-circle"></div>
            <div class="skeleton-block skeleton-label"></div>
          </div>
          <!-- Right column skeleton -->
          <div class="cert-right-column">
            <div class="cert-title-section">
              <div class="skeleton-block skeleton-title"></div>
              <div class="skeleton-block skeleton-badge"></div>
            </div>
            <div class="skeleton-table">
              <div class="skeleton-block skeleton-table-header"></div>
              <div class="skeleton-table-row" *ngFor="let r of [0, 1, 2]">
                <div class="skeleton-block skeleton-cell"></div>
                <div class="skeleton-block skeleton-cell"></div>
                <div class="skeleton-block skeleton-cell-sm"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Error state -->
    <div
      *ngIf="!isLoadingCertificates && certificatesLoadError"
      class="certificates-error-state"
    >
      <p class="error-message">
        Failed to load certificates. Please try again later.
      </p>
    </div>

    <!-- Loaded state -->
    <ng-container *ngIf="!isLoadingCertificates && !certificatesLoadError">
      <div class="certificates-container">
        <!-- Add Certificate Button -->
        <div class="add-certificate-section">
          <button
            class="add-certificate-button"
            (click)="toggleCertificateForm()"
            *ngIf="
              !showCertificateForm &&
              projectDetail &&
              projectDetail.certificates.length > 0
            "
          >
            +
          </button>
        </div>

        <!-- Show certificate form when active -->
        <app-certificate-form
          *ngIf="showCertificateForm"
          [isSubmitting]="isSubmittingCertificate"
          (submitCertificate)="handleCertificateSubmit($event)"
          (cancel)="handleCertificateCancel()"
        ></app-certificate-form>
      </div>

      <div class="certificates-grid">
        <div
          class="certificate-card"
          *ngFor="let cert of projectDetail?.certificates"
          [class]="'cert-status-' + cert.statusColor"
        >
          <div class="card-content">
            <!-- Columna izquierda: Icono + Status -->
            <div class="cert-left-column">
              <div class="cert-icon" [class]="'cert-icon-' + cert.statusColor">
                <img
                  src="../../../assets/icons/license.svg"
                  class="tech-icon-svg"
                />
              </div>
              <span
                class="cert-status-label"
                [class]="'cert-status-label-' + cert.statusColor"
              >
                {{ cert.status }}
              </span>
            </div>

            <!-- Columna derecha: Título + Badge + Detalles -->
            <div class="cert-right-column">
              <div class="cert-title-section">
                <h3 class="cert-title">{{ cert.name }}</h3>
                <span class="cert-type-badge" [class]="cert.type.toLowerCase()">
                  {{ cert.type }}
                </span>
              </div>

              <table class="cert-details-table">
                <thead>
                  <tr>
                    <th>Environment</th>
                    <th>Expiration Date</th>
                    <th style="width: 120px">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Each environment in its own row -->
                  <tr *ngIf="cert.dev">
                    <td>
                      <span
                        class="env-badge"
                        [class.expired]="isDateExpired(cert.dev)"
                        [class.valid]="!isDateExpired(cert.dev)"
                      ></span>
                      Dev
                    </td>
                    <td>
                      <!-- Edit mode -->
                      <input
                        *ngIf="
                          isEditingEnvironment(cert.name, cert.type, 'dev')
                        "
                        type="date"
                        class="date-input-inline"
                        [value]="editingCertificate?.newDate"
                        (input)="updateEditingDate($any($event.target).value)"
                        [disabled]="isUpdatingCertificate"
                      />
                      <!-- View mode -->
                      <span
                        *ngIf="
                          !isEditingEnvironment(cert.name, cert.type, 'dev')
                        "
                      >
                        {{ cert.dev | dateFormat }}
                      </span>
                    </td>
                    <td>
                      <!-- Edit mode actions -->
                      <div
                        *ngIf="
                          isEditingEnvironment(cert.name, cert.type, 'dev')
                        "
                        class="inline-actions"
                      >
                        <button
                          class="btn-save-inline"
                          (click)="saveCertificateEdit()"
                          [disabled]="isUpdatingCertificate"
                          title="Save"
                        >
                          ✓
                        </button>
                        <button
                          class="btn-cancel-inline"
                          (click)="cancelEditingCertificate()"
                          [disabled]="isUpdatingCertificate"
                          title="Cancel"
                        >
                          ✕
                        </button>
                      </div>
                      <!-- View mode actions -->
                      <button
                        *ngIf="
                          !isEditingEnvironment(cert.name, cert.type, 'dev')
                        "
                        class="btn-edit-inline"
                        (click)="
                          startEditingCertificate(
                            cert.name,
                            cert.type,
                            'dev',
                            cert.dev!
                          )
                        "
                        [disabled]="editingCertificate !== null"
                        title="Edit"
                      >
                        ✎
                      </button>
                    </td>
                  </tr>
                  <tr *ngIf="cert.preprod">
                    <td>
                      <span
                        class="env-badge"
                        [class.expired]="isDateExpired(cert.preprod)"
                        [class.valid]="!isDateExpired(cert.preprod)"
                      ></span>
                      Preprod
                    </td>
                    <td>
                      <!-- Edit mode -->
                      <input
                        *ngIf="
                          isEditingEnvironment(cert.name, cert.type, 'preprod')
                        "
                        type="date"
                        class="date-input-inline"
                        [value]="editingCertificate?.newDate"
                        (input)="updateEditingDate($any($event.target).value)"
                        [disabled]="isUpdatingCertificate"
                      />
                      <!-- View mode -->
                      <span
                        *ngIf="
                          !isEditingEnvironment(cert.name, cert.type, 'preprod')
                        "
                      >
                        {{ cert.preprod | dateFormat }}
                      </span>
                    </td>
                    <td>
                      <!-- Edit mode actions -->
                      <div
                        *ngIf="
                          isEditingEnvironment(cert.name, cert.type, 'preprod')
                        "
                        class="inline-actions"
                      >
                        <button
                          class="btn-save-inline"
                          (click)="saveCertificateEdit()"
                          [disabled]="isUpdatingCertificate"
                          title="Save"
                        >
                          ✓
                        </button>
                        <button
                          class="btn-cancel-inline"
                          (click)="cancelEditingCertificate()"
                          [disabled]="isUpdatingCertificate"
                          title="Cancel"
                        >
                          ✕
                        </button>
                      </div>
                      <!-- View mode actions -->
                      <button
                        *ngIf="
                          !isEditingEnvironment(cert.name, cert.type, 'preprod')
                        "
                        class="btn-edit-inline"
                        (click)="
                          startEditingCertificate(
                            cert.name,
                            cert.type,
                            'preprod',
                            cert.preprod!
                          )
                        "
                        [disabled]="editingCertificate !== null"
                        title="Edit"
                      >
                        ✎
                      </button>
                    </td>
                  </tr>
                  <tr *ngIf="cert.prod">
                    <td>
                      <span
                        class="env-badge"
                        [class.expired]="isDateExpired(cert.prod)"
                        [class.valid]="!isDateExpired(cert.prod)"
                      ></span>
                      Prod
                    </td>
                    <td>
                      <!-- Edit mode -->
                      <input
                        *ngIf="
                          isEditingEnvironment(cert.name, cert.type, 'prod')
                        "
                        type="date"
                        class="date-input-inline"
                        [value]="editingCertificate?.newDate"
                        (input)="updateEditingDate($any($event.target).value)"
                        [disabled]="isUpdatingCertificate"
                      />
                      <!-- View mode -->
                      <span
                        *ngIf="
                          !isEditingEnvironment(cert.name, cert.type, 'prod')
                        "
                      >
                        {{ cert.prod | dateFormat }}
                      </span>
                    </td>
                    <td>
                      <!-- Edit mode actions -->
                      <div
                        *ngIf="
                          isEditingEnvironment(cert.name, cert.type, 'prod')
                        "
                        class="inline-actions"
                      >
                        <button
                          class="btn-save-inline"
                          (click)="saveCertificateEdit()"
                          [disabled]="isUpdatingCertificate"
                          title="Save"
                        >
                          ✓
                        </button>
                        <button
                          class="btn-cancel-inline"
                          (click)="cancelEditingCertificate()"
                          [disabled]="isUpdatingCertificate"
                          title="Cancel"
                        >
                          ✕
                        </button>
                      </div>
                      <!-- View mode actions -->
                      <button
                        *ngIf="
                          !isEditingEnvironment(cert.name, cert.type, 'prod')
                        "
                        class="btn-edit-inline"
                        (click)="
                          startEditingCertificate(
                            cert.name,
                            cert.type,
                            'prod',
                            cert.prod!
                          )
                        "
                        [disabled]="editingCertificate !== null"
                        title="Edit"
                      >
                        ✎
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Show "no certificates" message when there are none -->
      <div
        class="no-certificates"
        *ngIf="
          projectDetail &&
          projectDetail.certificates.length === 0 &&
          !showCertificateForm
        "
      >
        <p>No certificates available for this project yet.</p>
        <br />
        <button
          class="add-certificate-button-large"
          (click)="toggleCertificateForm()"
          *ngIf="!showCertificateForm"
        >
          Add Certificate
        </button>
      </div>
    </ng-container>
  </div>

  <!-- Sección Comments -->
  <div class="content-section" id="comments" style="padding: 48px 24px">
    <div class="section-header">
      <h2>Comments</h2>
      <p class="section-subtitle">Project Comments and Notes</p>
    </div>

    <div class="comments-container">
      <!-- Add Comment Button -->
      <div class="add-comment-section">
        <button
          class="add-comment-button"
          (click)="toggleCommentForm()"
          *ngIf="!showCommentForm && comments.length > 0"
        >
          +
        </button>
      </div>

      <!-- Show comment form when active -->
      <app-comment-form
        *ngIf="showCommentForm"
        [isSubmitting]="isSubmittingComment"
        (submitComment)="handleCommentSubmit($event)"
        (cancel)="handleCommentCancel()"
      ></app-comment-form>

      <!-- Comments Table -->
      <div class="comments-table-container" *ngIf="comments.length > 0">
        <table class="comments-table">
          <thead>
            <tr>
              <th class="comment-col">Comment</th>
              <th class="author-col">Author</th>
              <th class="date-col">Date and Time</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let comment of comments">
              <td class="comment-content" [innerHTML]="comment.comment"></td>
              <td class="author-content">{{ comment.updatedBy }}</td>
              <td class="date-content">
                {{ comment.updatedAt | date: "MMM d, y, h:mm a" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Show "no comments" message when there are no comments -->
      <div
        class="no-comments"
        *ngIf="comments.length === 0 && !showCommentForm"
      >
        <p>No comments available for this project yet.</p>
        <br />
        <button
          class="add-comment-button-large"
          (click)="toggleCommentForm()"
          *ngIf="!showCommentForm"
        >
          Add Comment
        </button>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
